<template>
    <div class="top" v-if="showHeader">
        <van-nav-bar :title="title" left-arrow @click-left="handleClickLeft">
            <van-icon v-if="show" name="search" slot="right" />
            <van-icon v-if="showRight" name="search" slot="right" @click="handleSearchByDate"/>
        </van-nav-bar>
    </div>

</template>

<script>
    import {getUrlParamsTools} from "../util/tools";

    export default {
        name: "BaseHeader",
        props:{
            title:{
                type:String,
            },
            show:{
                type:Boolean,
                default:false,
            },
            showRight:{
                type:Boolean,
                default: false
            }
        },
        data(){
            return{
                showHeader:true,
            }
        },
        mounted(){
            const state = getUrlParamsTools('isPhone');
            if(state){
                this.showHeader = false;
            }
        },
        methods:{
            handleClickLeft(){
                this.$router.go(-1);
            },



            handleSearchByDate(){
                this.$router.push({
                    name:'searchByDate'
                })
            },
        }
    }
</script>
<style>
    .van-nav-bar .van-icon{
        color: #00BFFF!important;
    }
    .van-nav-bar__title{
        font-size: 18px!important;
        font-weight: bold!important;
    }
</style>
<style scoped>
    .top{
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 100;
    }

</style>